import React, { useState, useEffect } from "react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { REST_API } from "../../../services/constants";
import { seo } from "../../../components/seo.component";
import AuthService from "../../../services/auth.service.ts";
import authHeader from "../../../services/auth-header";
import TasksFinishedPieChart from "./charts/TasksFinishedPieChart";
import TopicsMandatoryPieChart from "./charts/TopicsMandatoryPieChart";

import "./account-manage.scss";
import ProfileImage from "../../../components/profile-image.component";

export default function ManageAccountPage() {
  const [userAnalyticData, setUserAnalyticData] = useState();

  useEffect(() => {
    seo({ title: "Campboard • Account" });
    updateUserAnalyticData();
  }, []);

  const updateUserAnalyticData = async () => {
    axios({
      method: "GET",
      url: REST_API + "/api/secure/users/session/get_analytics/",
      headers: await authHeader(),
    }).then((response) => {
      if (response.status === 200) {
        setUserAnalyticData(response.data);
      }
    });
  };

  return (
    <>
      <Row>
        <Col lg={4} md={12} sm={12} className="mb-3">
          <Card>
            <Card.Body>
              <Card.Title>Profilinformationen</Card.Title>

              <div className="profile-change-form mt-5 mb-3 mx-auto">
                <ProfileImage width={150} height={150} />
              </div>

              <Card.Title className="text-center mb-1">
                {AuthService.getLocalUser().firstname}{" "}
                {AuthService.getLocalUser().lastname}
              </Card.Title>
              <p className="text-center mb-0">
                {AuthService.getLocalUser().email}
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={8} md={12} sm={12}>
          <Card>
            <Card.Body>
              <Card.Title className="mb-5">Statistiken</Card.Title>

              <Row>
                <Col sm={12} md={7} lg={7} style={{ overflow: "hidden" }}>
                  <TasksFinishedPieChart data={userAnalyticData} />
                </Col>
                <Col sm={12} md={5} lg={5} style={{ overflow: "hidden" }}>
                  <TopicsMandatoryPieChart data={userAnalyticData} />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}
